<template>
  <div>
    <v-data-table
      :loading="loading"
      :headers="headersByType"
      :items="contracts"
      :server-items-length="meta.total"
      :footer-props="footerProps"
      :options="options"
      :page="page"
      :items-per-page="itemsPerPage"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :multi-sort="multiSort"
      v-on="listeners"
    >
      <template v-slot:item.buildings="{ item }">
        {{ buildingsToString(item) }}
      </template>

      <template v-slot:item.created_at="{ item }">
        {{ item.created_at | dateFormat }}
      </template>

      <template v-slot:item.start="{ item }">
        {{ item.start | dateFormat }}
      </template>

      <template v-slot:item.status_id="{ item }">
        <v-chip
          v-if="item.status.color"
          :color="item.status.color"
          text-color="white"
          small
        >
          {{ item.status.name }}
        </v-chip>
      </template>

      <template v-slot:item.action="{ item }">
        <div class="text-center">
          <v-list-item @click="show(item)">
            <v-list-item-title>
              <v-icon class="mr-1" small>mdi-eye</v-icon>
              {{ $t('ITEM.VIEW') }}
            </v-list-item-title>
          </v-list-item>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { isEqual } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';

export default {
  name: 'ContractsList',

  filters: {
    dateFormat
  },

  props: {
    contracts: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      default: () => ({
        total: -1
      })
    },
    options: {
      type: Object,
      default: () => {}
    },
    page: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    sortBy: {
      type: [String, Array],
      default: 'id'
    },
    sortDesc: {
      type: [Boolean, Array],
      default: false
    },
    multiSort: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'all',
      validator: prop => ['c', 'all'].includes(prop)
    }
  },

  data: () => ({
    footerProps: {
      showFirstLastPage: true,
      itemsPerPageOptions: [10, 50, 100]
    },
    columnsByType: {
      c: [0, 1, 2, 3, 4, 5, 6],
      all: [0, 1, 2, 3, 4, 5, 6, 7]
    }
  }),

  computed: {
    listeners: function() {
      return Object.assign({}, this.$listeners, {
        'update:options': this.updateOptions
      });
    },

    headers() {
      return [
        {
          text: this.$t('ORDERS.DATE_ENTERED'),
          value: 'created_at',
          width: '130px'
        },
        {
          text: this.$t('CONTRACTS.NAME'),
          value: 'name'
        },
        {
          text: this.$t('SERVICES.ITEM'),
          value: 'service.name'
        },
        {
          text: this.$t('BUILDINGS.ITEMS'),
          value: 'buildings',
          sortable: false
        },
        {
          text: this.$t('EREPORTER.PERIOD'),
          value: 'period.name'
        },
        {
          text: this.$t('CONTRACTS.PERIOD_STARTS'),
          value: 'start',
          width: '130px'
        },
        {
          text: this.$t('ITEM.STATUS'),
          value: 'status_id'
        },
        {
          text: this.$t('DATA_TABLE.ACTIONS'),
          value: 'action',
          align: 'center',
          sortable: false
        }
      ];
    },

    headersByType() {
      const columnsIndexes = this.columnsByType[this.type];

      return this.headers.filter((item, index) => {
        return columnsIndexes.indexOf(index) !== -1;
      });
    }
  },

  methods: {
    updateOptions(options) {
      if (isEqual(options, this.options)) {
        return;
      }

      this.$emit('update:options', options);
    },
    show(item) {
      this.$emit('show', item);
    },

    buildingsToString(contract) {
      if (!contract.buildings.length || !contract.specify_buildings) {
        return '';
      }

      return contract.buildings.map(item => item.name).join(', ');
    }
  }
};
</script>
